import type {
  ContactInquiryReceipt,
  ContactInquiryReceiptResponse,
  CreateContactInquiryRequest,
} from '@mds/shared/types/contact';

import { api } from '@/lib/api';

/**
 * Sends the contact form. The subject is one line of free text, at most 120
 * characters; the message at most 1000. The route is rate-limited per IP.
 */
export const sendContactInquiry = (
  body: CreateContactInquiryRequest,
): Promise<ContactInquiryReceipt> =>
  api.post<ContactInquiryReceiptResponse>('contact', body).then((r) => r.data);
